import api from "../../client";

export interface TranscriptData {
  id: string;
  clean_transcript: string;
  raw_transcript: string;
  created_at: string;
}

export interface TranscriptResponse {
  success: boolean;
  message: string;
  data: TranscriptData;
}

export const getLinkTranscriptRequest = async (
  linkId: string,
): Promise<TranscriptResponse> => {
  const { data } = await api.get<TranscriptResponse>(
    `/link/${linkId}/transcript`,
  );
  return data;
};
